import React from "react";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Card, { CardContent } from "material-ui/Card";
import { withStyles } from "material-ui/styles";
import styles from "./styles";

class PingSubtest extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      classes,
      translate,
      results,
      chartMeasurementUnit,
      subtestResultsDisplay,
      subtest,
      subtestRes
    } = this.props;

    return (
      <Grid container spacing={0}>
        <Grid xs={12} className={classes.topGrid}>
          <Typography className={classes.t_tar_text}>
            {translate("result_total_targets")}
          </Typography>
          <Typography className={classes.t_tar_no}>
            {results.data.subtests[subtest] &&
              results.data.subtests[subtest].totaltargets}
          </Typography>
        </Grid>
        <Grid item xs={6} className={classes.leftGrid}>
          <Typography className={classes.t_tar_text_p}>
            {translate("result_passed_targets")}
          </Typography>
          <Typography className={classes.t_tar_no_p}>
            {results.data.subtests[subtest] &&
              results.data.subtests[subtest].targetpassed}
          </Typography>
        </Grid>
        <Grid item xs={6} className={classes.rightGrid}>
          <Typography className={classes.t_tar_text_f}>
            {translate("result_failed_targets")}
          </Typography>
          <Typography className={classes.t_tar_no_f}>
            {results.data.subtests[subtest] &&
              results.data.subtests[subtest].targetfailed}
          </Typography>
        </Grid>
        {/* </Grid> */}
      </Grid>
    );
  }
}

export default withStyles(styles)(PingSubtest);
